<template lang="pug">
.listing-response-item
  //- Feedback response
  template(v-if="responseType === 'feedback'")
    v-divider.my-3
    .pl-16.pr-6
      .d-flex.align-start
        .text-sm.font-semibold.flex-grow-1 {{ $t('internal_notes') }}
        v-btn.button-xs.underline.px-0.mt-n1(text :loading="leftBtnLoading" @click="$emit('leftBtnClicked')") {{ leftBtnText }}
        v-btn.button-xs.underline.px-0.mt-n1.mr-n4(text :loading="rightBtnLoading" @click="$emit('rightBtnClicked')") {{ rightBtnText }}
      .text-sm {{ response }}

  v-row(v-else no-gutters)
    v-col(:cols="offsetCols" :xl="offsetXlCols" :class="{'mr-8':isLargerScreen}")
      div
    //- No idea why offset not working here
    v-col
      //- Google review response
      template(v-if="responseType === 'googleReview'")
        .d-flex
          v-divider.ml-2.mr-3.border.neutral400(vertical)
          div
            .text-sm.font-semibold {{ $t('response') }}
            .text-sm.font-medium {{ response }}
        .d-flex.justify-start
          v-btn.button-sm.underline(text :loading="leftBtnLoading" @click="$emit('leftBtnClicked')") {{ leftBtnText }}
          v-btn.button-sm.underline(text :loading="rightBtnLoading" @click="$emit('rightBtnClicked')") {{ rightBtnText }}
</template>

<script>
export default {
  name: 'ListingResponseItem',
  props: {
    offsetCols: {
      type: Number,
      default: 2 
    },
    responseType: {
      type: String,
      required: true,
      validator(value) {
        return ['googleReview', 'feedback'].includes(value)
      }
    },
    response: {
      type: String,
      default: null
    },
    rightBtnText: {
      type: String,
      required: true 
    },
    leftBtnText: {
      type: String,
      required: true 
    },
    rightBtnLoading: {
      type: Boolean,
    },
    leftBtnLoading: {
      type: Boolean,
    },
  },
  computed: {
    offsetXlCols() {
      return this.offsetCols - 1
    },
    isLargerScreen() {
      return this.$vuetify.breakpoint.xl
    },
  },
}
</script>

<style scoped>
.border {
  border-width: 2px;
}
</style>
